export const thread_reg = /\[i=s](((?!\[\/i\]).)*)\[\/i\]/;